import { NewOrderConfirmationDialogComponent } from './new-order-confirmation/new-order-confirmation.component';
import { TransferConfirmationDialogComponent } from './transfer-confirmation/transfer-confirmation.component';

export const dialogs = [NewOrderConfirmationDialogComponent, TransferConfirmationDialogComponent];

export * from './new-order-confirmation/new-order-confirmation.component';
export * from './transfer-confirmation/transfer-confirmation.component';
